import BaseMap from '../../BaseMap.jsx'
import LeftPanel from './LeftPanel.jsx'
import ToolBar from './ToolBar.jsx'
import usePluginIrrelevant from './usePluginIrrelevant.mjs'
import useReadMap from './useReadMap.mjs'

const components = {LeftPanel, ToolBar}

export default function AnalyseMap({
    bizNodeType,
    mode,
    pkid,
    prjPatternId,
    rev,
    ...props
}) {
    const readMap = useReadMap({bizNodeType, mode, pkid, prjPatternId, rev})

    const plugins = [
        usePluginIrrelevant(),
    ]

    return (
        <BaseMap
            components={components}
            plugins={plugins}
            prjPatternId={prjPatternId}
            readMap={readMap}
            {...props}
        />
    )
}
